/* Normal document flow and original-speed looping, entirely independent of scroll progress. */
(() => {
  const section=document.querySelector('.home-film');if(!section)return;
  const video=section.querySelector('video'),film=section.querySelector('.journey-film');
  const reduced=matchMedia('(prefers-reduced-motion: reduce)');
  let visible=true,pending=false,titlePlayed=false;
  const heading=section.querySelector('#film-heading');
  const titleText=heading.querySelector('.film-brand-text');
  const titleFlash=document.createElement('span');
  titleFlash.className='film-brand-flash';titleFlash.setAttribute('aria-hidden','true');titleFlash.setAttribute('translate','no');
  heading.append(titleFlash);
  function paintTitleFlag(){
    const box=titleText.getBoundingClientRect(),w=box.width*3,h=box.height;
    if(!w||!h)return;
    const skew=h*.32,edge=[.28,.425,.575,.72].map(t=>t*w);
    const band=(a,b,color)=>`<path fill="${color}" d="M${a+skew} 0H${b+skew}L${b-skew} ${h}H${a-skew}Z"/>`;
    const sun=Array.from({length:42},(_,i)=>{const angle=-Math.PI/2+i*Math.PI/21,r=h*(i%2?.23:.46);return `${w*.5+Math.cos(angle)*r},${h*.52+Math.sin(angle)*r}`;}).join(' ');
    // One shared texture keeps the sun centred in the moving white stripe,
    // clipped to the actual letterforms rather than floating above the word.
    const svg=`<svg xmlns="http://www.w3.org/2000/svg" width="${w}" height="${h}" viewBox="0 0 ${w} ${h}"><path fill="#f4f0e9" d="M0 0H${w}V${h}H0Z"/>${band(edge[0],edge[1],'#e94343')}${band(edge[1],edge[2],'#fffaf0')}${band(edge[2],edge[3],'#3eb978')}<polygon fill="#f4c849" points="${sun}"/></svg>`;
    titleText.style.setProperty('--title-flag',`url("data:image/svg+xml,${encodeURIComponent(svg)}")`);
    titleFlash.style.setProperty('--title-flag',`url("data:image/svg+xml,${encodeURIComponent(svg)}")`);
  }
  const titleResize=new ResizeObserver(()=>{if(!titlePlayed||heading.classList.contains('heritage-title')||heading.classList.contains('heritage-flash'))paintTitleFlag();});
  titleResize.observe(titleText);
  video.muted=true;video.defaultMuted=true;video.playsInline=true;video.playbackRate=1;video.loop=true;
  function sync(){
    if(!visible||document.hidden||reduced.matches){video.pause();return;}
    if(pending||!video.paused)return;
    pending=true;video.play().catch(()=>{}).finally(()=>{pending=false;});
  }
  video.addEventListener('canplay',sync);
  video.addEventListener('playing',()=>{
    if(!titlePlayed&&video.currentTime<1&&!reduced.matches){paintTitleFlag();titlePlayed=true;heading.classList.add('heritage-title');}
  });
  heading.addEventListener('animationend',event=>{
    if(event.animationName==='heritage-colors'){
      heading.classList.remove('heritage-title');
      if(!reduced.matches){titleFlash.textContent=titleText.textContent;paintTitleFlag();heading.classList.add('heritage-flash');}
      else titleResize.disconnect();
    }
    if(event.animationName==='heritage-afterglow'){heading.classList.remove('heritage-flash');titleFlash.textContent='';titleResize.disconnect();}
  });
  video.addEventListener('timeupdate',()=>film.classList.toggle('macro-shot',video.currentTime>=2.25));
  new IntersectionObserver(([entry])=>{visible=entry.isIntersecting;sync();},{threshold:0}).observe(section);
  document.addEventListener('visibilitychange',sync);reduced.addEventListener('change',sync);
  // A real gesture may enable autoplay on a restricted browser, without blocking it.
  ['pointerup','touchend'].forEach(type=>section.addEventListener(type,sync,{passive:true}));
  addEventListener('pageshow',sync);
  addEventListener('pagehide',()=>video.pause());
  sync();
})();
